function isUndefined(element) {
	return element === null || element === 'undefined' || typeof (element) === 'undefined' || typeof (element) === false;
}

function dateToLocaleTimeString(dateString, asHTML) {
	var addHTML = true;
	if (!isUndefined(asHTML)) {
		addHTML = asHTML;
	}
	if (dateString === null || dateString === '') {
		return '';
	}

	if (addHTML) {
		return moment(dateString).locale($('#locale').data().locale).format('L') + '&nbsp;&nbsp;' + moment(dateString).locale($('#locale').data().locale).format('LT');
	}
	return moment(dateString).locale($('#locale').data().locale).format('L') + '  ' + moment(dateString).locale($('#locale').data().locale).format('LT');
}

function dateToLocaleString(dateString) {
	if (dateString === null || dateString === '') {
		return '';
	}

	return moment(dateString).locale($('#locale').data().locale).format('L');
}

function dateToLocaleLongTimeString(dateString) {
	if (dateString === null || dateString === '') {
		return '';
	}

	return moment(dateString).locale($('#locale').data().locale).format('LLLL');
}

function dateToLocaleFormatString(dateString, format) {
	if (dateString === null || dateString === '') {
		return '';
	}

	return moment(dateString).locale($('#locale').data().locale).format(format);
}

function setDateFormat() {

	jQuery.each($('.c-format-t'), function(i, element) {
		$(element).text(dateToLocaleTimeString(parseInt($(element).text()), false));
	});
	jQuery.each($('.c-format-d'), function(i, element) {
		$(element).text(dateToLocaleString($(element).text()));
	});
	jQuery.each($('.c-format-long-d'), function(i, element) {
		$(element).text(dateToLocaleLongTimeString($(element).text(), false));
	});
	jQuery.each($('.c-format-d-mm-yy'), function (i, element) {
		$(element).text(dateToLocaleFormatString($(element).text(), 'MM/YYYY'));
	});
	jQuery.each($('.c-format-d-yy'), function (i, element) {
		$(element).text(dateToLocaleFormatString($(element).text(), 'YYYY'));
	});

}

function getLocaleDateFormat() {
	return moment().locale($('#locale').data().locale)._locale._longDateFormat.L;
}

function getLocaleDateFormatMask() {
	return moment().locale($('#locale').data().locale)._locale._longDateFormat.L.replace('DD', '99').replace('MM', '99').replace('YYYY', '9999');
}

function getDatepickerFormat(dateFormat) {
	return dateFormat.replace('DD', 'dd').replace('MM', 'mm').replace('YYYY', 'yy');
}

function getMomentFormat(dateFormat) {
	return dateFormat.replace('dd', 'DD').replace('mm', 'MM').replace('yy', 'YYYY');
}

function stringToDate(dateString) {
	if (dateString === null || dateString === '') {
		return null;
	}
	if (dateString === 'today') {
		return moment().toDate();
	}
	return moment(dateString).toDate();
}

function dateToString(date) {
	if (date === null) {
		return '';
	}
	return moment(date).format('YYYY-MM-DD');
}

function serializeFormData(form, ignore, addEmptyValues) {

	var rCRLF = /\r?\n/g;
	var data = '';
	var ignoreSelector = '[name]';
	var ignoreSelectorDisabled = '';

	if (!isUndefined(ignore) && ignore !== '') {
		ignoreSelector = 'input:not(' + ignore + '),select:not(' + ignore + '),textarea:not(' + ignore + ')';
		ignoreSelectorDisabled = '[name]:disabled:not(' + ignore + ')';
	}
	var arrKeyValuePairs = new FormData();
	var selector = ignoreSelector;
	if (ignoreSelectorDisabled !== '') {
		selector = ignoreSelector + ',' + ignoreSelectorDisabled;
	}
	jQuery.each($(form).find(selector), function(i, element) {
		var isRadioCheckbox = $(element).is(':radio') || $(element).is(':checkbox');
		if (!isUndefined(element.name) && element.name !== '') {
			var val = jQuery(this).val();
			if ($(element).hasClass('c-select2')) {
				val = $(element).select2('data');
			} else if ($(element).hasClass('datepicker') && val.replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
				val = '';
			}

			if (val !== null && val !== '' && (!isRadioCheckbox || (isRadioCheckbox && $(element).is(':checked')))) {
				var key = element.name;
				var value = '';
				if (jQuery.isArray(val)) {
					jQuery.map(val, function (mapVal) {
						if (value !== '') {
							value += '|';
						}
						value += mapVal.id.replace(rCRLF, "\r\n");
					});
				} else {
					value = val.replace(rCRLF, "\r\n");
				}

				if ($(element).hasClass('datepicker')) {
					var picker = $(element).data('picker');
					value = dateToString(picker.getDate());
				}
				if ($(element).hasClass('tt-input-decimal')) {
					try {
						value = stringToNumber(value);
					} catch (NaNError) {
					}
				}
				if ($(element).length && !isUndefined(element.dataset.calculatedValue) && element.dataset.calculatedValue !== '') {
					try {
						value = stringToNumber(element.dataset.calculatedValue);
					} catch (NaNError) {
					}
				}
				arrKeyValuePairs.append(key, value);
			} else {
				if (addEmptyValues) {
					if (arrKeyValuePairs.indexOf(element.name) < 0) {
						arrKeyValuePairs.append(key, '');
					}
				}
			}
		}
	});

	return arrKeyValuePairs;
}

function resetForm(element) {

	if (!$(element).find('form').hasClass('tt-no-reset-form')) {

		$(element).find('form').validate().resetForm();

		if (!$(element).find('form').hasClass('tt-no-reset-hidden-input')) {
			$(element).find('form').find('input[type="hidden"]:not([data-no-reset="no-reset-value"])').val("");
		}
		$(element).find('form').attr('action', $(element).find('form').attr('init-action'));
		$(element).find('form .c-works').empty();
		$(element).find('form .alert').remove();
		$(element).find('form .c-select2').select2().val([]);
		$(element).find('.c-dialog-title-add').removeClass('hide');
		$(element).find('.c-dialog-title-edit').addClass('hide');
		$(element).find('[name="_method"]').remove();
	}
}


module.exports.isUndefined = isUndefined;
module.exports.dateToLocaleFormatString = dateToLocaleFormatString;
module.exports.dateToLocaleString = dateToLocaleString;
module.exports.dateToLocaleTimeString = dateToLocaleTimeString;
module.exports.dateToLocaleLongTimeString = dateToLocaleLongTimeString;
module.exports.setDateFormat = setDateFormat;
module.exports.getLocaleDateFormat = getLocaleDateFormat;
module.exports.getLocaleDateFormatMask = getLocaleDateFormatMask;
module.exports.getDatepickerFormat = getDatepickerFormat;
module.exports.getMomentFormat = getMomentFormat;
module.exports.stringToDate = stringToDate;
module.exports.serializeFormData = serializeFormData;
module.exports.resetForm = resetForm;

